// Central membership config. To change checkout targets, edit `lookupKey` here.
// CTAs call the Stripe checkout backend using these lookup keys.

export const TIERS = {
  network: {
    id: "network",
    name: "NETWORK",
    price: "99",
    lookupKey: "network_monthly",
    accent: "cyan",
    badge: null,
    creditHeadline: ["GET $99", "MONTHLY STORE CREDIT"],
    perks: ["+ 20% OFF ALL ORDERS"],
    support: "Your entry into The Biohacker Network.",
    benefits: [
      "$99 monthly store credit",
      "20% off all orders",
      "PeptIQ Premium included",
      "Biohacker Network membership",
      "Private community access",
      "Member research and resources",
      "Guides and playbooks",
      "Member offers and drops",
    ],
    callout: ["PAY $99", "GET $99 CREDIT", "+ SAVE 20%"],
    cta: "JOIN NETWORK — $99/MO",
  },
  pro: {
    id: "pro",
    name: "PRO",
    price: "199",
    lookupKey: "pro_monthly",
    accent: "pro",
    badges: ["MOST POPULAR", "BEST VALUE"],
    creditHeadline: ["GET $250", "MONTHLY STORE CREDIT"],
    perks: ["+ 30% OFF ALL ORDERS", "+ FREE SHIPPING"],
    support: "More credit. Bigger savings. Deeper access.",
    highlight: "GET MORE IN STORE CREDIT THAN THE COST OF MEMBERSHIP.",
    benefits: [
      "$250 monthly store credit",
      "30% off all orders",
      "FREE shipping",
      "PeptIQ Premium included",
      "Full Biohacker Network membership",
      "Premium member benefits",
      "Premium research and resources",
      "Priority drops and opportunities",
      "Enhanced member rewards",
    ],
    callout: ["PAY $199", "GET $250 CREDIT", "PLUS 30% MEMBER PRICING", "+ FREE SHIPPING"],
    cta: "UNLOCK PRO — $199/MO",
    microcopy: "$250 monthly credit • 30% member savings • Free shipping",
  },
  elite: {
    id: "elite",
    name: "ELITE",
    price: "299",
    lookupKey: "elite_monthly",
    accent: "gold",
    badge: "MAXIMUM BENEFITS",
    creditHeadline: ["GET $400", "MONTHLY STORE CREDIT"],
    perks: ["+ 40% OFF ALL ORDERS", "+ FREE SHIPPING"],
    support: "Maximum value. Maximum access.",
    benefits: [
      "$400 monthly store credit",
      "40% off all orders",
      "FREE shipping",
      "FREE bacteriostatic water",
      "PeptIQ Premium included",
      "Elite Biohacker Network access",
      "VIP member benefits",
      "Priority drops and releases",
      "VIP events and opportunities",
      "Highest member rewards level",
    ],
    callout: ["PAY $299", "GET $400 CREDIT", "+ SAVE 40%", "+ FREE SHIPPING", "+ FREE BAC WATER"],
    cta: "JOIN ELITE — $299/MO",
  },
};

// Mobile order: PRO first, then Network, then Elite
export const MOBILE_ORDER = ["pro", "network", "elite"];
// Desktop order: Network, PRO (center), Elite
export const DESKTOP_ORDER = ["network", "pro", "elite"];

export function getAccentVariant(accent) {
  if (accent === "pro") return "pro";
  if (accent === "gold") return "gold";
  return "default";
}

export const COMPARISON = [
  { label: "Monthly Price", network: "$99", pro: "$199", elite: "$299" },
  { label: "Monthly Store Credit", network: "$99", pro: "$250", elite: "$400" },
  { label: "Member Discount", network: "20%", pro: "30%", elite: "40%" },
  { label: "Free Shipping", network: false, pro: true, elite: true },
  { label: "Free Bac Water", network: false, pro: false, elite: true },
  { label: "PeptIQ Premium", network: true, pro: true, elite: true },
  { label: "Community Access", network: true, pro: true, elite: true },
  { label: "Premium Benefits", network: false, pro: true, elite: true },
  { label: "VIP / Elite Access", network: false, pro: false, elite: true },
];
